import React, { useState } from "react";
import "./Kontakt.scss";
import { details } from "../../shared/shared";

export default function Kontakt() {
  const [form, setForm] = useState({ name: "", tel: "", text: "" });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <div className="kontakt">
      <div className="kontakt__header">
        <div className="kontakt__header-inner">
          <div className="kontakt__ornament">✦ ✝ ✦</div>
          <h1 className="kontakt__title">Kontakt</h1>
          <p className="kontakt__sub">
            Pišite nam za porudžbine, pitanja ili saradnju
          </p>
        </div>
      </div>

      <div className="kontakt__body">
        <div className="kontakt__info">
          <h2 className="kontakt__info-title">Informacije</h2>
          <ul className="kontakt__info-list">
            <li>
              <span className="kontakt__info-icon">✉</span>
              <span>ikone.rs@gmail.com</span>
            </li>
            <li>
              <span className="kontakt__info-icon">☏</span>
              <span>+381 60 000 0000</span>
            </li>
            <li>
              <span className="kontakt__info-icon">◈</span>
              <span>Beograd, Srbija</span>
            </li>
          </ul>
          <div className="kontakt__info-note">
            Sve ikone su ručno pisane. Moguće su individualne porudžbine
            po Vašim željama i dimenzijama.
          </div>
        </div>

        <div className="kontakt__form-wrap">
          {sent ? (
            <div className="kontakt__success">
              <div className="kontakt__success-icon">✝</div>
              <h3>Poruka je poslata</h3>
              <p>Javićemo Vam se u najkraćem roku.</p>
            </div>
          ) : (
            <form className="kontakt__form" onSubmit={handleSubmit}>
              {details.map((d) => (
                <div key={d.name} className="kontakt__field">
                  <label className="kontakt__label" htmlFor={d.name}>
                    {d.title}
                  </label>
                  {d.name === "text" ? (
                    <textarea
                      id={d.name}
                      name={d.name}
                      className="kontakt__textarea"
                      value={form[d.name]}
                      onChange={handleChange}
                      rows={5}
                      required
                    />
                  ) : (
                    <input
                      id={d.name}
                      name={d.name}
                      className="kontakt__input"
                      value={form[d.name]}
                      onChange={handleChange}
                      required
                    />
                  )}
                </div>
              ))}
              <button type="submit" className="kontakt__submit">
                Pošaljite poruku
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
